//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Field } from 'redux-form';
import ContainerRowReduxTextField from '../../components/common/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from '../ProjectDemeter/common/ContainerRowReduxCheckboxField'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowReduxAutoCompleteAndOverrideField from '../../components/common/ContainerRowReduxAutoCompleteAndOverrideField'
import ContainerRowReduxSmartTextReadonlyField from '../../components/common/ContainerRowReduxSmartTextReadonlyField'
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import * as actions from '../../redux/rhea/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/genericFlowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

const styles = {
    locationTextFieldStyle: {
        width: '270px',
        paddingBottom: '10px'
    },
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const rhea:ReducerState$Type = (props.rhea:any)
    
    if (isInvalidDoc && Object.keys(rhea.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        return (
            <div>
                <button type="button" onClick={()=> submitOpenActionDialog()} 
                className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
            </div>    
        )
    }
}

const vendorNameField='vendorName'
const vendorIdField='vendorId'
const internalIdField='internalId'
const invNoField='invNo'
const invDateField='invDate'
const deptNoField='deptNo'
const requestorField='requestor'
const requestorIdField='requestorId'
const requestorNameField='requestorName'
const modifierField='modifier'
const accountField='account'

const vendorAutoCompleteDataSourceConfig = {
    text: vendorNameField,
    value: vendorNameField
}

const requestorAutoCompleteDataSourceConfig = {
    text: requestorNameField,
    value: requestorNameField
}

const glStringNotFoundOnChange=(e:any,props: InvoiceHeaderForm$Props)=>{
    const changeFieldValue = (props.changeFieldValue:any)
    if (e.target.checked && props.vendorName){
        const vendors = (props.rhea.vendors:any)
        let search = vendors.find(v=>v.vendor_name===(props.vendorName:any));
        if (search){
            changeFieldValue('glString',search['gl_string'])
        }
    }else {
        changeFieldValue('glString','')
    }
}

const processInternalIdByVendorName=(vendorName:string,props: InvoiceHeaderForm$Props)=>{
    const changeFieldValue = (props.changeFieldValue:any)

    if (vendorName){
        const vendors = props.rhea.vendors
        if (vendors && vendorName){
            let search = vendors.find(v=>v.vendorName===vendorName);
            if (search){
                changeFieldValue(internalIdField,search[vendorIdField])
            }
        }else {
            changeFieldValue(internalIdField,'')
        }
    }else {
        changeFieldValue(internalIdField,'')
    }
}

const processRequestorIdByRequestor=(requestor:String,props: InvoiceHeaderForm$Props)=>{
    const changeFieldValue = (props.changeFieldValue:any)

    if (requestor){
        const requestors = props.rhea.requestors
        if (requestors && requestor){
            let search = requestors.find(v=>v.requestorName===requestor);
            if (search){
                changeFieldValue(requestorIdField,search[requestorIdField])
            }
        }else {
            changeFieldValue(requestorIdField,'')
        }
    }else {
        changeFieldValue(requestorIdField,'')
    }
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt, rhea } = this.props
        if (!rhea.vendorsLoaded){
            const populateVendorsList=(this.props.populateVendorsList:any)
            populateVendorsList(jwt);
        }
        if (!rhea.requestorsLoaded){
            const populateRequestorsList=(this.props.populateRequestorsList:any)
            populateRequestorsList(jwt)
        }
    }
    
    componentDidUpdate(prevProps: InvoiceHeaderForm$Props){
        //VendorName props checking
        const prevVendorName = (prevProps.vendorName:any)
        const vendorName = (this.props.vendorName:any)
        if (prevVendorName !== vendorName){
            processInternalIdByVendorName(vendorName,this.props)
        }
        //Requestor props checking
        const prevRequestor = (prevProps.requestor:any)
        const requestor = (this.props.requestor:any)
        if (prevRequestor !== requestor) {
            processRequestorIdByRequestor(requestor,this.props)
        }
    }

    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,rhea,isInvalidDoc,actConfDialog,jwt,taskAcceptedInfoId,
            isOverrideVendorName,isGlStringNotFound,vendorName,requestor} = (this.props:any);
        const changeFieldValue = (this.props.changeFieldValue:any)
        
        if (rhea.invoiceSubmitted) {
            return <Redirect to='/projectRhea/submittedForm' />;
        }
        
        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={vendorNameField} 
                    autoCompleteDatasourceConfig={vendorAutoCompleteDataSourceConfig}
                    label={'Vendor Name'}
                    datas={rhea.vendors}
                    checkboxField={'isOverrideVendorName'}
                    checkboxLabel={'Override this Vendor Name field'}
                    isOverride={isOverrideVendorName}
                    changeFieldValue={changeFieldValue}
                    parentProps={this.props}
                />
                {vendorName?(
                <ContainerRowReduxSmartTextReadonlyField 
                    textField={internalIdField}
                    textLabel={'Internal ID'}
                    isTextDisable={true}
                />
                ):null}
                
                <ContainerRowReduxTextField field={invNoField} label={'Invoice Number'} />
                <ContainerRowReduxTextField field={invDateField} label={'Invoice Date'} />
                <ContainerRowReduxTextField field={'poNo'} label={'PO Number'} />
                <ContainerRowReduxTextField field={deptNoField} label={'Deparment Number'} textType={'number'} />
                
                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={requestorField} 
                    autoCompleteDatasourceConfig={requestorAutoCompleteDataSourceConfig}
                    label={'Requestor'}
                    datas={rhea.requestors}
                    parentProps={this.props}
                />
                {requestor?(
                <ContainerRowReduxSmartTextReadonlyField 
                    textField={requestorIdField}
                    textLabel={'Requestor ID'}
                    isTextDisable={true}
                />
                ):null}
                
                <ContainerRowReduxTextField field={modifierField} label={'Modifier'} textType={'number'}/>
                <ContainerRowReduxTextField field={accountField} label={'Account'} textType={'number'} />

                <ContainerRowReduxSmartTextReadonlyField 
                    textField={'glString'}
                    textLabel={'GL String'}
                    isTextDisable={isGlStringNotFound}
                    checkboxField={'isGlStringNotFound'}
                    checkboxLabel={'GL String not found in the document'}
                    parentProps={this.props}
                    checkboxOnChange={glStringNotFoundOnChange}
                />
                <ContainerRowReduxTextField field={'tax'} label={'Tax'} textType={'number'}  />
                <ContainerRowReduxTextField field={'additional'} label={'Additional'} textType={'number'}  />
                <ContainerRowReduxTextField field={'total'} label={'Total'} textType={'number'}  />
                <ContainerRowError errorMsg={rhea.error} />
                
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideVendorName: selector(state, 'isOverrideVendorName'),
        isGlStringNotFound: selector(state, 'isGlStringNotFound'),
        vendorName: selector(state, 'vendorName'),
        internalId: selector(state, internalIdField),
        requestor: selector(state, requestorField),
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.morpheus, jwt, taskAcceptedInfoId))  
      },
      populateVendorsList: (jwt:string)=>{
        dispatch(actions.populateVendorsList(jwt))  
      },
      refreshCacheValue: (key: any, value: any)=>{
        dispatch(actions.refreshCacheValue(key,value))    
      },
      populateRequestorsList: (jwt:string)=>{
        dispatch(actions.populateRequestorsList(jwt))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/ProjectRhea/InvoiceHeaderForm.js